(function () {
  if (window.__tk9EmergencyRuntimeFix) return;
  window.__tk9EmergencyRuntimeFix = true;

  function removeMasks() {
    document.querySelectorAll("#bm-preload-mask").forEach(function (node) {
      node.remove();
    });
  }

  function cleanProductHref(href) {
    try {
      var url = new URL(href, window.location.origin);
      if (url.origin !== window.location.origin || !/^\/products\//.test(url.pathname)) return href;
      url.searchParams.set("view", "default");
      url.searchParams.set("_ab", "0");
      url.searchParams.set("_fd", "0");
      url.searchParams.set("_sc", "1");
      return url.pathname + url.search + url.hash;
    } catch (error) {
      return href;
    }
  }

  function rewriteProductLinks(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('a[href*="/products/"]').forEach(function (anchor) {
      var current = anchor.getAttribute("href") || "";
      var next = cleanProductHref(current);
      if (next !== current) anchor.setAttribute("href", next);
    });
  }

  function run() {
    removeMasks();
    rewriteProductLinks(document);
  }

  document.addEventListener("click", function (event) {
    var anchor = event.target && event.target.closest ? event.target.closest('a[href*="/products/"]') : null;
    if (!anchor) return;
    var current = anchor.getAttribute("href") || "";
    var next = cleanProductHref(current);
    if (next === current) return;
    anchor.setAttribute("href", next);
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    window.location.assign(next);
  }, true);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }

  if (window.MutationObserver) {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        run();
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  window.setTimeout(run, 50);
  window.setTimeout(run, 250);
  window.setTimeout(run, 1000);
  window.setTimeout(run, 3000);
  window.setTimeout(run, 8000);
})();
